import AboutTemplate from "../../components/about/AboutTemplate";
import Page from "../Page";
import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Section from "../../components/about/Section";
import ResponsiveImage from "../../components/about/ResponsiveImage";

const TaskBlocks = () => {
  return (
    <Page className="about-page task-blocks-page" pageKey="task-blocks">
      <AboutTemplate>
        <Typography variant="h1">Task Blocks</Typography>

        <Section>
          <Typography variant="p1">
            Task blocks let you dedicate a specific time slot in your day to
            working on one or more{" "}
            <Link
              component={RouterLink}
              to="/about/features/tasks"
              variant="p1Link"
            >
              tasks
            </Link>{" "}
            from your stack. They bridge the gap between your task list and your
            daily schedule.
          </Typography>
          <ResponsiveImage
            pageKey="taskBlocks"
            imageName="task-block"
            size="large"
          />
        </Section>

        <Section title="Creating a task block">
          <Typography variant="p1">
            When inserting a new block, select <strong>"Task Block"</strong> as
            the block type. You'll see a list of your incomplete tasks - select
            one or more tasks that you want to work on during this time slot.
          </Typography>
          <Typography variant="p1">
            You can search through your tasks to quickly find the ones you're
            looking for.
          </Typography>
          <ResponsiveImage
            pageKey="taskBlocks"
            imageName="task-picker"
            size="medium"
          />
        </Section>

        <Section title="Multiple tasks in one block">
          <Typography variant="p1">
            A single task block can hold multiple tasks. This is useful when you
            want to batch related tasks together into one focused work session.
          </Typography>
          <Typography variant="p1">
            Each task is shown within the block, so you can see at a glance what
            you've planned to work on.
          </Typography>
        </Section>

        <Section title="Editing a task block">
          <Typography variant="p1">
            Click on a task block to select it. From the Edit Block panel, you
            can add or remove tasks, adjust the time range, or delete the block
            entirely.
          </Typography>
          <ResponsiveImage
            pageKey="taskBlocks"
            imageName="edit-task-block"
            size="medium"
          />
        </Section>

        <Section title="When to use task blocks">
          <Typography variant="p1">
            Task blocks are ideal when you want to commit specific time in your
            day to making progress on your tasks. Rather than hoping you'll get
            around to it, you're carving out dedicated time.
          </Typography>
          <Typography variant="p1">
            They work especially well alongside{" "}
            <Link
              component={RouterLink}
              to="/about/features/task-targeting"
              variant="p1Link"
            >
              targeted tasks
            </Link>{" "}
            - target a task to commit to it, then schedule a task block to
            commit to <em>when</em> you'll do it.
          </Typography>
        </Section>
      </AboutTemplate>
    </Page>
  );
};

export default TaskBlocks;
